import FeaturedCollection from './FeaturedCollection.component';

export default FeaturedCollection;